import { Injectable } from '@angular/core';
import { WadoService } from '../services/wado.service';

import { EstensaExternalDocsService } from '../services/angularjs/estensa-external-docs.service';
import { ExternalDocument, ExternalDocSearchInfo } from '../models/estensa-models.model';


@Injectable({
    providedIn: 'root',
})
export class ExternalDocsService {

    constructor(private estensaExternalDocsService: EstensaExternalDocsService,
        private wadoService: WadoService) {
    }


    loadAllExternalDocs(info: ExternalDocSearchInfo) {
        return this.estensaExternalDocsService.loadAllExternalDocs(info);
    }


    getExternalDoc(externalDocument: ExternalDocument) { // Vedi vna-pdf-modal per capire come fare il pipe
        let contentType: string;

        switch (externalDocument.fileType) {
            case 1: // PDF
                contentType = "application/pdf";
                break;
            case 2: // JPEG
                contentType = "image/jpeg";
                break;
            case 3: // PNG
                contentType = "image/png";
                break;
        }

        return this.wadoService.get(externalDocument.sopInstanceUID, contentType);
    }

    deleteDocument(externalDocument: ExternalDocument, isDocForPatient: boolean) {
        if (isDocForPatient)
            return this.estensaExternalDocsService.removePatientExternalDoc(externalDocument);

        return this.estensaExternalDocsService.removeExamExternalDoc(externalDocument);
    }

    updateDocument(externalDocument: ExternalDocument, isDocForPatient: boolean) {
        if (isDocForPatient)
            return this.estensaExternalDocsService.updatePatientExternalDoc(externalDocument);

        return this.estensaExternalDocsService.updateExamExternalDoc(externalDocument);
    }

    addExternaDoc(externalDocument: ExternalDocument) {
        return this.estensaExternalDocsService.uploadExternalDoc(externalDocument);
    }
}
